// ── Shared modern checkout/payment page background ──────────────────────────
// Replaces the old low-res `momoCod.png` raster (a 90%-white overlay stretched
// over a tiled bitmap, which looked washed-out and pixelated). This is pure CSS
// — a soft brand-tinted gradient "mesh" plus a faint vector dot grid — so it
// stays perfectly crisp at any screen resolution / device pixel ratio, and the
// white payment card pops cleanly on top of it.
//
// Spread into a payment screen's outer container style:  style={{ ...,
// ...paymentBackgroundStyle }}. One source of truth, so every payment screen
// (Retailer/Wholesaler, Restaurant, Brand, …) stays consistent.

const paymentBackgroundStyle = {
  background: [
    // faint dot grid — vector, crisp at any DPI
    "radial-gradient(rgba(1, 113, 9, 0.05) 1px, transparent 1.4px) 0 0 / 24px 24px",
    // soft brand-tinted glows for a modern, premium gradient-mesh feel
    "radial-gradient(circle at 12% 18%, rgba(1, 113, 9, 0.12), transparent 38%)",
    "radial-gradient(circle at 88% 82%, rgba(229, 147, 59, 0.10), transparent 40%)",
    // light base wash
    "linear-gradient(135deg, #f3f8f4 0%, #eef3f8 100%)",
  ].join(", "),
  backgroundAttachment: "fixed",
};

export default paymentBackgroundStyle;
